class Wishlist {

    constructor() {

        this.items = [];

    }

    async init() {

        if (window.seekWishlistSettings.customerId) {

            // await this.mergeGuestWishlist();

            await this.load();

        } else {

            this.items = WishlistStorage.load();

        }

        WishlistButtons.init(this);
        WishlistCounter.update(this.items);
        WishlistPage.render(this.items);

    }

    async load() {

        this.items = await window.WishlistAPI.get();

    }

    async toggle(variantId) {

        const exists = this.items.some(
            item => String(item.variantId) === String(variantId)
        );

        try{

          if (exists) {

              await window.WishlistAPI.remove(variantId);

              WishlistToast.show(
                  "Removed from your wishlist",
                  "This product has been removed."
              );

          } else {

              await window.WishlistAPI.add(variantId);

              WishlistToast.show(
                  "Added to your wishlist",
                  "This product has been saved."
              );

          }

        }catch(error){

          WishlistToast.show(
              error.message || "Something went wrong",
              "error"
          );

          return;

        }

        await this.load();

        WishlistButtons.refresh(this.items);

        WishlistCounter.update(this.items);

        WishlistPage.render(this.items);

    }

}

window.Wishlist = new Wishlist();

document.addEventListener(
    "DOMContentLoaded",
    () => window.Wishlist.init()
);